import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/en/industries/medical-devices/")({
  head: () => buildRouteHead("/en/industries/medical-devices"),
  component: IndustryPage,
});

